import { defineComponent as _defineComponent } from 'vue'
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import MyProjectsSectionHeader from '@/views/my-projects/components/MyProjectsSectionHeader.vue';
import { ref } from 'vue';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsSection',
  props: {
  icon: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  helpText: {
    type: String,
    default: ''
  },
  paddingBottom: {
    type: String,
    default: '36px'
  }
},
  setup(__props) {



const isHelpOpen = ref(false);


return { __sfc: true,isHelpOpen, BCXHelpTextTriggerIcon, MyProjectsSectionHeader, BCXInfoCollapsible }
}

})